<script>
    function aplicarSonido(numero) {
        const audio = new Audio();
        audio.src = 'assets/sonidos/note' + numero + '.wav';
        audio.load();
        audio.play();
    }

    function manejarTecla(event, numero) {
        if (event.key === 'Enter' || event.key === ' ') {
            aplicarSonido(numero);
        }
    }
</script>

<main>
    <div class="row">
        <div class="col-lg-6">
            <div class="list-group">
                <button on:click={() => aplicarSonido(1)} on:keydown={(event) => manejarTecla(event, 1)} class="list-group-item list-group-item-action" style="background-color: red;"></button>
                <button on:click={() => aplicarSonido(2)} on:keydown={(event) => manejarTecla(event, 2)} class="list-group-item list-group-item-action" style="background-color: orange;"></button>
                <button on:click={() => aplicarSonido(3)} on:keydown={(event) => manejarTecla(event, 3)} class="list-group-item list-group-item-action" style="background-color: yellow;"></button>
                <button on:click={() => aplicarSonido(4)} on:keydown={(event) => manejarTecla(event, 4)} class="list-group-item list-group-item-action" style="background-color: green;"></button>
                <button on:click={() => aplicarSonido(5)} on:keydown={(event) => manejarTecla(event, 5)} class="list-group-item list-group-item-action" style="background-color: blue;"></button>
                <button on:click={() => aplicarSonido(6)} on:keydown={(event) => manejarTecla(event, 6)} class="list-group-item list-group-item-action" style="background-color: purple;"></button>
            </div>
        </div>
    </div>
</main>

<style>
    .list-group-item {
        cursor: pointer;
        height: 50px;
        border: none;
    }
    .row {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }
    .list-group-item:active {
        opacity: 0.7;
    }
	main {
		background-color: #c5f467;
	}
</style>
